import { render } from "./Storage_process_delete_button.vue?vue&type=template&id=69d1df8e&scoped=true"
import script from "./Storage_process_delete_button.vue?vue&type=script&lang=js"
export * from "./Storage_process_delete_button.vue?vue&type=script&lang=js"

import "./Storage_process_delete_button.vue?vue&type=style&index=0&id=69d1df8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d1df8e"]])

export default __exports__